import { combineReducers } from "redux";
import users from "./users";
import clients from "./clients";
import agents from "./agents";
import chat from "./chat";
import workflows from "./workflows";

export default combineReducers({
  users,
  clients,
  agents,
  chat,
  workflows,
});
